export default Object.freeze({
  ACRES_CLASSES: {
    namespace: 'AcresClasses',
    url: '/ownershipAcresClasses',
  },
  COUNTRIES: {
    namespace: 'Countries',
    url: '/countries',
  },
  FOREST_PROTECTION_UNITS: {
    namespace: 'ForestProtectionUnits',
    url: '/forestProtectionUnits',
  },
  FOREST_PROTECTION_DISTRICTS: {
    namespace: 'ForestProtectionDistricts',
    url: '/forestProtectionDistricts',
  },
  REGIONS: {
    namespace: 'regions',
    url: '/regions',
  },
  LAND_USE_CATEGORIES: {
    namespace: 'LandUseCategories',
    url: '/landUseCategories',
  },
  LANDOWNER_REPORT_STATUSES: {
    namespace: 'LandownerReportStatuses',
    url: '/landownerReportStatuses',
  },
  NOTIFICATION_STATUSES: {
    namespace: 'NotificationStatuses',
    url: '/notificationStatuses',
  },
  OWNERSHIP_TYPES: {
    namespace: 'OwnershipTypes',
    url: '/ownershipTypes',
  },
  PRODUCT_TYPES: {
    namespace: 'ProductTypes',
    url: '/productTypes',
  },
  SALE_TYPES: {
    namespace: 'SaleTypes',
    url: '/saleTypes',
  },
  SPECIALTY_PRODUCT_TYPES: {
    namespace: 'SpecialtyProductTypes',
    url: '/specialtyProductTypes',
  },
  SPECIES_TYPES: {
    namespace: 'SpeciesTypes',
    url: '/speciesTypes',
  },
  STATES: {
    namespace: 'States',
    url: '/states',
  },
  STRUCTURE_TYPES: {
    namespace: 'StructureTypes',
    url: '/structureTypes',
  },
  STUMPAGE_PRICE_TYPES: {
    namespace: 'StumpagePriceTypes',
    url: '/stumpagePriceTypes',
  },
  STUMPAGE_UNITS: {
    namespace: 'StumpageUnits',
    url: '/stumpageUnits',
  },
  SWS_COMPLIANCE_TYPES: {
    namespace: 'SwsComplianceTypes',
    url: '/swsComplianceTypes',
  },
  TOWNS: {
    namespace: 'Towns',
    url: '/towns',
    idKey: 'geocodeNum',
  },
  REGIONALOFFICES: {
    namespace: 'RegionalOffices',
    url: '/regionaloffices',
  },
  TREE_SPECIES: {
    namespace: 'TreeSpecies',
    url: '/treeSpecies',
  },
  WATER_FEATURE_TYPES: {
    namespace: 'WaterFeatureTypes',
    url: '/waterFeatureTypes',
  },
});
